export default "__VITE_ASSET__c242c5f3__"